import type { TemplateRef } from '@angular/core';
import { Directive, input } from '@angular/core';

@Directive({
	selector: 'vp-tab-menu-item, [vp-tab-menu-item], [vpTabMenuItem]',
})
export class TabMenuItemDirective {
	label = input.required<string>();
	name = input.required<string>();
	content = input<TemplateRef<unknown> | null>(null);
}
